import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'

type Props = {
  showModal: boolean
  handleShowModalAlert: any
}

const AlertContent: React.FC<Props> = ({showModal, handleShowModalAlert}) => {
  const [isShow, setIsShow] = useState<boolean>(true)

  useEffect(() => {
    setIsShow(showModal)
  }, [showModal])

  const handleClose = (isOk: boolean) => {
    setIsShow(false)
    handleShowModalAlert(false, isOk)
  }

  return (
    <Modal show={isShow} centered size='sm'>
      <div className='p-10'>
        <p className='h6 text-center'>Konfirmasi Simpan</p>
        <p className='mt-10'>
          Silakan pastikan semua informasi sudah benar. Apakah Anda ingin melanjutkan dan menyimpan
          data ini
        </p>

        <button
          className='btn btn-primary btn-sm w-100 mt-10'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          onClick={() => handleClose(true)}
        >
          Ya, Simpan
        </button>

        <button
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
          onClick={() => handleClose(false)}
        >
          Batal
        </button>
      </div>
    </Modal>
  )
}

const AlertModal: React.FC<Props> = ({showModal, handleShowModalAlert}) => {
  return <AlertContent showModal={showModal} handleShowModalAlert={handleShowModalAlert} />
}

export default AlertModal
